import React, { useState, useMemo } from 'react'
import MainContainer from '../UI/MainContainer'
import TableContainer from '../UI/TableContainer'
import TableSection from '../UI/TableSection'
import { useDispatch } from 'react-redux'
import { setSnackBarCopy, toggleSnackBar } from '../UI/Store/actions'
import Snackbar from '../UI/Snackbar'
import TableTopSection from 'UI/TableTopSection'
import { Button, Divider, Select } from '@duik/it'
import { InputContainer } from 'Login/styles'
import DateInput from './Components/DateInput'
import { getTicketList, TicketType } from './dummy-data'
import useShallowEqualSelector from 'hooks/global'
import { ApplicationState } from 'Store/intialState'

const TicketsExport: React.FC<{ history: { push: (path: string) => void } }> = ({ history }) => {
  // const [searchValue, setSearchValue] = useState('')
  const [startDate, setStartDate] = useState(new Date())
  const [endDate, setEndDate] = useState(new Date())
  const [_project, _setProject] = useState('')

  const ticketList = useMemo(() => getTicketList(startDate), [])

  const { snackBarCopy, snackBarVisible } = useShallowEqualSelector((state: ApplicationState) => ({
    snackBarCopy: state.ui.snackBarCopy,
    snackBarVisible: state.ui.snackBarVisible
  }))

  const dispatch = useDispatch()

  const handleSnackBar = () => {
    dispatch(toggleSnackBar(true))
    setTimeout(() => {
      dispatch(toggleSnackBar(false))
    }, 2500)
  }

  const handleSetEndDate = (date: Date) => {
    if (date < startDate) {
      dispatch(setSnackBarCopy('Cannot set end date before start date'))
      handleSnackBar()
      return
    }
    setEndDate(date)
  }

  const handleSetStartDate = (date: Date) => {
    if (date > endDate) {
      dispatch(setSnackBarCopy('Cannot set start date after end date'))
      handleSnackBar()
      return
    }
    setStartDate(date)
  }

  const handleExportClick = () => {
    dispatch(setSnackBarCopy('Exporting...'))
    handleSnackBar()

    const csvFileFromJson = (json: TicketType[], fileName: string) => {
      const fields = Object.keys(json[0]) as (keyof TicketType)[]
      const replacer = (key: string, value: string | null) => (value === null ? '' : value)
      const csv = json.map(row =>
        fields.map(fieldName => JSON.stringify(row[fieldName], replacer)).join(',')
      )
      csv.unshift(fields.join(',')) // add header column
      const csvArray = csv.join('\r').replace(/"/g, '')
      const blob = new Blob([csvArray], { type: 'text/csv;charset=utf-8;' })
      // @ts-ignore
      if (navigator.msSaveBlob) {
        // IE 10+
        // @ts-ignore
        navigator.msSaveBlob(blob, fileName)
      } else {
        const link = document.createElement('a')
        if (link.download !== undefined) {
          // feature detection
          // Browsers that support HTML5 download attribute
          const url = URL.createObjectURL(blob)
          link.setAttribute('href', url)
          link.setAttribute('download', fileName)
          link.style.visibility = 'hidden'
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
        }
      }
    }

    csvFileFromJson(ticketList, 'tickets.csv')
    dispatch(setSnackBarCopy('Exported!'))
    history.push('/app/tickets')
  }

  return (
    <MainContainer>
      <TableContainer>
        <TableTopSection
          title="Export Tickets"
          additionalElement={
            <div style={{ height: '50px', display: 'flex', alignItems: 'center' }}>
              <a href="/app/tickets">
                <Button
                  style={{
                    background: 'none',
                    color: '#289C91',
                    border: 'none',
                    boxShadow: 'none',
                    fontWeight: 'normal',
                    fontSize: '16px'
                  }}
                >
                  Cancel
                </Button>
              </a>
              <Button
                style={{
                  background: '#36AF47',
                  color: 'white',
                  width: '176px',
                  height: '38px',
                  fontWeight: 'normal',
                  fontSize: '16px'
                }}
                onClick={handleExportClick}
              >
                Export
              </Button>
            </div>
          }
        />

        <TableSection>
          <div
            style={{
              display: 'flex',
              gridGap: '20px',
              flexWrap: 'wrap',
              flex: 1,
              padding: '30px'
            }}
          >
            <div
              style={{
                flex: 1
              }}
            >
              <h4>Details</h4>
              <p>Select the dates and projects to include</p>
            </div>
            <div
              style={{
                display: 'flex',
                gridGap: '20px',
                flexWrap: 'wrap',
                justifyContent: 'center',
                flex: 2
              }}
            >
              <div style={{ flex: 1 }}>
                <h5>Start Date</h5>
                <DateInput
                  buttonStyle={{ width: '340px' }}
                  date={startDate}
                  setDate={handleSetStartDate}
                />
              </div>
              <div style={{ flex: 1 }}>
                <h5>End Date</h5>
                <DateInput
                  buttonStyle={{ width: '340px' }}
                  date={endDate}
                  setDate={handleSetEndDate}
                />
              </div>
              <div style={{ flex: 1 }}>
                <h5>Project</h5>
                <InputContainer style={{ width: '340px' }}>
                  <Select
                    placeholder="All"
                    options={[
                      { label: 'All', value: 0 },
                      { label: 'Acme Construction Site 1', value: 1 },
                      { label: 'Acme Construction Site 2', value: 2 },
                      { label: 'Acme Construction Site 3', value: 3 },
                      { label: 'Acme Construction Site 4', value: 4 }
                    ]}
                  />
                </InputContainer>
              </div>
            </div>
          </div>
          <Divider />
        </TableSection>
      </TableContainer>
      {snackBarVisible && <Snackbar text={snackBarCopy} />}
    </MainContainer>
  )
}

export default TicketsExport
